import React from 'react'
import { any, async, fromJSX, Updater, Widget } from 'widgets-for-react'
import { KnowledgeSearchLayout } from './knowledgeSearchLayout'
import { knowledgeSearchPageStateUpdaters, KnowledgeSearchResult, KnowledgeSearchState } from './knowledgeSearchState'

export const knowledgeSearchWidget = (
  state: KnowledgeSearchState
): Widget<Updater<KnowledgeSearchState>> =>
  any([
    async<KnowledgeSearchResult>(state.result).map(
      knowledgeSearchPageStateUpdaters.updateSearchResult
    ),
    fromJSX(() => (
      <KnowledgeSearchLayout {...state} />
    ))
  ])